import { z } from 'zod';

import type { TFunction } from 'i18next';

export function createRefundClientCertificateFormSchema(t: TFunction) {
  return z
    .object({
      refund_target: z.enum(['cash_register', 'deposit']),
      cash_register_id: z.string(),
      refund_reason_id: z
        .string()
        .min(1, { message: t('validation_required') }),
      description: z.string().optional(),
    })
    .refine(
      (values) =>
        values.refund_target === 'deposit' || values.cash_register_id !== '',
      {
        path: ['cash_register_id'],
        message: t('validation_required'),
      },
    );
}

export type RefundClientCertificateFormValues = z.infer<
  ReturnType<typeof createRefundClientCertificateFormSchema>
>;
